import SubLabel from "components/Atoms/Sublabel";
import Table from "components/Tables/Table";
import React from "react";
import { useMutation } from "@tanstack/react-query";
import { useValidators } from "formvalidation/hooks";
import CustomAppLabelTranslationAddModal from "./CustomAppLabelTranslationAddModal";
import ValidatorContext from "formvalidation/FormContext";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import PanelSegmentType from "components/panels/PanelSegment/PanelSegment";
import { CustomSection } from "components/MainSectionTemplate/types";
interface Props {
  clientId: number;
  customAppLabelTranslations: server.dto.CustomAppLabelTranslation[]
}

const CustomAppLabelTranslations = (props: Props) => {
  const [translations, setTranslations] = React.useState(props.customAppLabelTranslations);
  const [displayNewModal, setDisplayNewModal] = React.useState(false);

  const addMutation = useMutation(window.CoreApi.CustomAppLabelTranslation.Store);
  const validation = useValidators();

  const onDelete = async (translation: server.dto.CustomAppLabelTranslation) => {
    window.displayDeleteConfirmationModal({
      onDeleteHandler: async () => {
        const res = await window.CoreApi.CustomAppLabelTranslation.Delete(props.clientId, translation.key);
        if (res.data.hasErrors) {
          return;
        }
        setTranslations(res.data.data);
      }
    })
  }

  const addNewTranslation = async (translationFor: server.dto.CustomAppLabel, language: server.dto.Language, customAppLabelTranslation: string) => {
    const validationRes = await validation.validateAll();
    if (validationRes.hasErrors) {
      validationRes.scrollToFirstError();
      return;
    }

    const res = await addMutation.mutateAsync({
      clientId: props.clientId,
      translation: translationFor.value,
      value: customAppLabelTranslation,
      language: language.value
    });
    if (res.data.hasErrors) {
      return;
    }

    setTranslations(res.data.data);
    setDisplayNewModal(false);
  }

  return <SectionPanel.Panel
    header={<>
      <PanelSegmentType.Title title={"Custom translations"} />
      <PanelSegmentType.Button onClick={() => setDisplayNewModal(true)} label={RESX.Buttons.btnNew} type="secondary" />
    </>}
  >
    <Table
      items={translations}
      isLoading={false}
      getKey={translation => `${translation.language.toString()}-${translation.key.toString()}`}
      onDelete={onDelete}
      columns={[{
        key: "labelName",
        header: "",
        render: translation => {

          const customAppLabel = serverReference.customAppLabels.find(t => t.value === translation.key);

          return <div>
            <div>{customAppLabel.description}</div>
            <SubLabel>{customAppLabel.value}</SubLabel>
          </div>
        }
      }, {
        key: "language",
        header: "",
        render: translation => {
          const language = serverReference.languages.find(l => l.value === translation.language);
          return `${language.value} (${language.twoLetterTag})`
        }
      }, {
        key: "value",
        header: "",
        render: translation => translation.value
      }]}
      hideHeader
    />

    <ValidatorContext settings={validation.validatorSettings}>
      {displayNewModal && <CustomAppLabelTranslationAddModal
        clientId={props.clientId}
        customAppLabelTranslations={translations}
        addCustomAppLabelTranslation={addNewTranslation}
        mutation={addMutation}
        onClose={() => setDisplayNewModal(false)}
      />}
    </ValidatorContext>
  </SectionPanel.Panel>
}

export const customAppLabelTranslationsSection = (clientId: number, customAppLabelTranslations: server.dto.CustomAppLabelTranslation[]): CustomSection => {
  return {
    key: "customAppLabelTranslations",
    type: "custom",
    render: () => <CustomAppLabelTranslations key="customAppLabelTranslations" clientId={clientId} customAppLabelTranslations={customAppLabelTranslations} />
  }
}
export default CustomAppLabelTranslations;